import React from 'react';
import styles from './device-info.module.scss';
import classNames from 'classnames';
import { useAppStore } from '../../app.context';
import { useLocation, useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { About } from '../about';
import { Advantages } from '../advantages';

const DeviceInfo = observer(() => {
  const {
    general: { activeStep, setActiveStep }
  } = useAppStore();

  const navigate = useNavigate();

  return (
    <div className={styles.main}>
      <div className={styles.nav}>
        <div
          className={styles.btn}
          onClick={() => {
            navigate('/devices');
            setActiveStep(1);
          }}
        >
          <img src='/img/back.svg' alt='back' />
          Назад
        </div>
        <div className={styles.buttonBlock}>
          <div
            className={classNames(styles.btn, {
              [styles.isActive]: activeStep === 1
            })}
            onClick={() => setActiveStep(1)}
          >
            Про девайс
          </div>
          <div
            className={classNames(styles.btn, {
              [styles.isActive]: activeStep === 2
            })}
            onClick={() => setActiveStep(2)}
          >
            Переваги
          </div>
          <div
            className={classNames(styles.btn, {
              [styles.isActive]: activeStep === 3
            })}
            onClick={() => setActiveStep(3)}
          >
            Стіки TEREA
          </div>
        </div>
      </div>
      <div
        className={classNames(styles.content, {
          [styles.isTerea]: activeStep === 3,
          [styles.isAdvantages]: activeStep === 2
        })}
      >
        {activeStep === 1 && <About />}
        {activeStep === 3 && (
          <div className={styles.terea}>
            <img src='/img/terea.png' />
          </div>
        )}
        {activeStep === 2 && <Advantages />}
      </div>
    </div>
  );
});

export { DeviceInfo };
